import BackButtonToolbar from "features/BackButtonToolbar";
import { Create, SimpleForm, useNotify, useRedirect, useStore } from "react-admin";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { useNotifyError } from "utils/useNotifyError";
import CreateForm from "./CreateForm";
import { normalizeStudyGroupsPayload } from "./components/utils";
import { STREAMS_FILTERS_KEY } from "./List";

const CreateStreamWeeklySchedule = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notify = useNotify();
  const notifyError = useNotifyError();
  const redirect = useRedirect();
  const [storedFilters] = useStore(STREAMS_FILTERS_KEY, null);

  const initialValues = storedFilters
    ? {
        academicYearId: storedFilters.academicYearId,
        studyTypeId: storedFilters.studyTypeId,
        academicSessionType: storedFilters.sessionType,
      }
    : {};
  const isStored = Object.keys(initialValues).length > 0;

  const handleSave = async values => {
    const payload = {
      ...values,
      disciplineSchedules: values.disciplineSchedules?.map(schedule => ({
        ...schedule,
        weeklySchedule: schedule.weeklySchedule?.map(slot =>
          normalizeStudyGroupsPayload(slot, values.curriculumIds),
        ),
      })),
    };

    try {
      await dataProvider.customRequest(studentRequests.createStreamWeeklySchedule(), payload, "POST");
      notify("Записът е създаден", { type: "success" });
      redirect(-1);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <Create
        title="Създаване на занятия в поток"
        actions={<BackButtonToolbar />}
      >
        <SimpleForm
          onSubmit={handleSave}
          defaultValues={initialValues}
        >
          <CreateForm isStored={isStored} />
        </SimpleForm>
      </Create>
      <ConflictErrorDialog />
    </>
  );
};

export default CreateStreamWeeklySchedule;
